import { type AnalyticsEventName } from './types/AnalyticsEventName';

export type Name<T extends AnalyticsEventName> = `analytics.${T}`;

export class AnalyticsEvent<T extends AnalyticsEventName> extends Event {
  constructor(public name: Name<T>) {
    super(name);
  }
}
